import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

interface ExportButtonProps {
  onExport: () => void;
  label?: string;
  disabled?: boolean;
}

/**
 * ExportButton - CSV export button for analytics data
 *
 * Simple button component for exporting data
 * Uses download icon and consistent styling
 */
export default function ExportButton({
  onExport,
  label = 'Export CSV',
  disabled = false,
}: ExportButtonProps) {
  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={onExport}
      disabled={disabled}
      sx={{ minWidth: 140 }}
    >
      {label}
    </Button>
  );
}
